import { Button, Col, Modal, Popconfirm, Row, Space, Tooltip, Input } from 'antd';
import HTTPService from '../../../utils/makerequest';
import { IPageData } from '../../../interfaces/page-data';
import { useEffect, useRef, useState } from 'react';
import { StateLoader } from '../../../redux/StateLoader';
import { IAuthentication, UserRole } from '../../../interfaces/authentication';
import toast from 'react-hot-toast';
import '../PrinterManagement/Device.css';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import moment from 'moment';
import MUIDatagrid, { IMUIDataGridColumns } from '../../../AltisComponent/MUIDataGrid';
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { Toast } from 'primereact/toast';

const FaultManagement: React.FunctionComponent<any> = (props) => {
    const { onSetPage } = props;
    const { t } = useTranslation();
    const loader = new StateLoader();
    const userInfo: IAuthentication = loader.loadAuthState();
    const [careData, setCareData] = useState({ data: [], count: 0 });
    const dataGridRef = useRef<any>(null);
    const [selectedRows, setSelectedRows] = useState<any[]>([]);
    //const [activityData, setActivityData] = useState<any[]>([]);
    const [selectedmaintenanceId, setSelectedmaintenanceId] = useState(null);
    const [newIsCompleted, setNewIsCompleted] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [isModalVisibleDelete, setIsModalVisibleDelete] = useState(false)
    const [completionDescription, setCompletionDescription] = useState('');

    const toast = useRef<Toast>(null);

    const pageData: IPageData = {
        title: t('fault'),
        loaded: true,
    };

    useEffect(() => {
        onSetPage(pageData);
        dataGridRef.current.GetAllData()
        //ActivityFilter()
    }, [i18n.language]);


    const handleCancel = () => {
        setIsModalVisible(false);
    };


    const ActivityFilter = (e?) => {
        HTTPService.GET(`/Activity/allActivityName?companyId=${userInfo?.companyId}`).then((response) => {
            if (!response.data) return;
            if (response.status === 200) {
                //setActivityData(response.data);
            } else if (response.status === 450) {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t(response.data),
                    life: 3000
                });
            }
        });
    };

    const showModal = (id, currentStatus) => {
        setSelectedmaintenanceId(id);
        setNewIsCompleted(!currentStatus);
        setIsModalVisible(true);
    };

    const handleOk = () => {
        if (!completionDescription.trim()) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('description_required'),
                life: 3000
            });
            return;
        }
        handleCheckboxChange(selectedmaintenanceId, newIsCompleted, completionDescription);
        setCompletionDescription('');
        setIsModalVisible(false);
    };


    const handleCheckboxChange = async (id: number, isCompleted: boolean, description: string) => {
        try {
            const response = await HTTPService.PUT(
                `/Maintenance/isCompleted?maintenanceId=${id}&description=${encodeURIComponent(description)}`,
                {}
            );

            if (response.status === 200) {
                toast.current?.show({
                    severity: 'success',
                    summary: t('success'),
                    detail: t('update_success'),
                    life: 3000
                });
                dataGridRef.current.GetAllData();
            } else {
                toast.current?.show({
                    severity: 'error',
                    summary: t('errors'),
                    detail: t('update_failed'),
                    life: 3000
                });
            }
        } catch (error) {
            console.error('Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        }
    };


    const handleRowSelection = (newSelection: any) => {
        setSelectedRows(newSelection);
    };

    const handleDeleteClick = (maintenanceId: number) => {
        setSelectedmaintenanceId(maintenanceId);
        setIsModalVisibleDelete(true);
    };

    const CancelCare = (maintenanceId: number) => {
        if (!maintenanceId) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('invalid_maintenance_id'),
                life: 3000
            });
            return;
        }

        HTTPService.DELETE(`/Maintenance/deleteFaultRecord?maintenanceId=${maintenanceId}`).then(
            (response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: t('cancel_fault'),
                        life: 3000
                    });
                    dataGridRef.current.GetAllData();
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            }
        ).catch(error => {
            console.error('Delete Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        });
    };

    const DeleteCare = (maintenanceId: number) => {
        if (!maintenanceId) {
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('invalid_maintenance_id'),
                life: 3000
            });
            return;
        }

        HTTPService.DELETE(`/Maintenance/deleteFault?maintenanceId=${maintenanceId}`).then(
            (response) => {
                if (response.status === 200) {
                    toast.current?.show({
                        severity: 'success',
                        summary: t('success'),
                        detail: t('delete_fault'),
                        life: 3000
                    });
                    dataGridRef.current.GetAllData();
                } else {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('errors'),
                        detail: t(response.data),
                        life: 3000
                    });
                }
            }
        ).catch(error => {
            console.error('Delete Error:', error);
            toast.current?.show({
                severity: 'error',
                summary: t('errors'),
                detail: t('error_message'),
                life: 3000
            });
        });
    };

    const FaultFilter = (e?) => {
        const filters = e?.filters;

        if (filters?.maintenanceStartDate && Array.isArray(filters.maintenanceStartDate)) {
            const [startDate, endDate] = filters.maintenanceStartDate;
            filters.startDate_Start = startDate;
            filters.startDate_Finish = endDate;
            delete filters.maintenanceStartDate;
        }

        if (filters?.priority !== undefined) {
            if (filters.priority === "" || filters.priority === null) {
                delete filters.priority;
            } else {
                filters.priority = [Number(filters.priority)];
            }
        }

        const body = {
            sortColumn: e?.sortField,
            sortOrder: e?.sortOrder || 'asc',
            pageSize: e?.pageSize,
            page: e?.page,
            companyId: userInfo?.companyId,
            description: filters?.description,
            activityId: filters?.activityId ? parseInt(filters.activityId) : null,
            priority: filters?.priority,
            maintenanceResponsible: filters?.maintenanceResponsible,
            maintenanceStartDate: filters?.maintenanceStartDate,
            isCompleted: filters?.isCompleted,
            ...filters,
        };

        HTTPService.POST(`/Maintenance/filtersFaultRecord`, body)
            .then((response) => {
                if (!response.data) return;
                if (response.status === 200) {
                    const formattedData = response.data.data.map(item => ({
                        ...item,
                        maintenanceId: item.maintenanceId || item.id,
                        key: item.maintenanceId || item.id
                    }));
                    setCareData({
                        data: formattedData,
                        count: response.data.count
                    });
                } else if (response.status !== 450) {
                    toast.current?.show({
                        severity: 'error',
                        summary: t('mistake'),
                        detail: t('mistake'),
                        life: 3000
                    });
                }
            });
    };

    const priority = {
        [t('Low')]: 0,
        [t('Medium')]: 1,
        [t('High')]: 2,
        [t('Highest')]: 3
    }


    const columns: IMUIDataGridColumns[] = [
        ...(userInfo.role == UserRole.AltisAdmin ? [{
            title: t('Company Name'),
            key: 'companyName',
            isSorting: true,
            placeHolder: t('Company Name'),
        }] : []),
        {
            title: t('activity_name'),
            key: 'activityName',
            placeHolder: t('activity_name'),
            isSorting: true,
            hideFilter: true,
            hideColumnMenu: true,
            /*render: (value) => {
                if (!Array.isArray(activityData)) return value;

                const activity = activityData?.find(a => a.activityId === value);
                return <div style={{ textAlign: 'left' }}>
                    {activity ? activity.activityName : value}
                </div>;
            }*/
        },
        {
            title: t('Priority'),
            key: 'priority',
            placeHolder: t('priority'),
            isSorting: true,
            headerAlign: 'left',
            align: 'left',
            enumValues: priority,
            render: (value) => {
                let iconColor = '';
                switch (value?.toLowerCase()) {
                    case 'low':
                        iconColor = '#52c41a'; // green
                        break;
                    case 'medium':
                        iconColor = '#faad14'; // yellow
                        break;
                    case 'high':
                        iconColor = '#ff4d4f'; // orange
                        break;
                    case 'highest':
                        iconColor = '#cc0000'; // red
                        break;
                    default:
                        iconColor = '#000000'; // black for unknown priority
                }

                return (
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px'
                    }}>
                        <ExclamationCircleFilled style={{
                            color: iconColor,
                            fontSize: '16px'
                        }} />
                        <span style={{ color: 'black' }}>{t(value)}</span>
                    </div>
                );
            }
        },
        {
            title: t('description'),
            key: 'description',
            placeHolder: t('description'),
            align: 'left',
        },
        {
            title: t('faultResponsible'),
            key: 'maintenanceExternalResponsibleName',
            placeHolder: t('faultResponsible'),
        },
        {
            title: t('maintenanceStartDate'),
            key: 'maintenanceStartDate',
            placeHolder: t('maintenanceStartDate'),
            isSorting: true,
            dataType: 'date',
            render: (text) => {
                return moment(text).format('DD-MM-YYYY HH:mm')
            }
        },
        {
            title: t('faultstatus'),
            key: 'isCompleted',
            placeHolder: t('faultstatus'),
            render: (text, record) => {
                return (
                    <Tooltip title={record.isCompleted ? t('isFaultMessageComp') : t('isFaultMessage')}>
                        <Button
                            style={{ marginLeft: '30px' }}
                            onClick={() => {
                                if (record?.maintenanceId) {
                                    showModal(record.maintenanceId, record.isCompleted);
                                } else {
                                    toast.current?.show({
                                        severity: 'error',
                                        summary: t('errors'),
                                        detail: t('invalid_record'),
                                        life: 3000
                                    });
                                }
                            }}
                            disabled={record.isCompleted}
                            size="small"
                        >
                            {record.isCompleted ? t('completed') : t('incomplete')}
                        </Button>
                    </Tooltip>
                );
            }
        },
        {
            title: t('operations'),
            key: 'operations',
            placeHolder: t('Operations'),
            isSorting: false,
            hideFilter: true,
            hideColumnMenu: true,
            render: (order, record) => {
                const canDelete = userInfo.role === UserRole.Admin || userInfo.role === UserRole.AltisAdmin;
                return (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-start' }}>
                        <Space>
                            {canDelete && (
                                <Popconfirm
                                    title={t('delete_confirm')}
                                    onConfirm={() => {
                                        const idToDelete = record?.maintenanceId || record?.id;
                                        if (idToDelete) {
                                            DeleteCare(idToDelete);
                                        }
                                    }}
                                    onCancel={() => {
                                        const idToCancel = record?.maintenanceId || record?.id;
                                        if (idToCancel) {
                                            CancelCare(idToCancel);
                                        }
                                    }}
                                    okText={t('permanently_delete')}
                                    cancelText={t('cancel')}
                                    okButtonProps={{
                                        danger: true
                                    }}
                                    disabled={record.isCompleted}
                                >
                                    <Tooltip title={t('delete')} placement="top">
                                        <Button
                                            size='small'
                                            icon={<DeleteOutlined />}
                                            style={{
                                                width: '60px',
                                                borderRadius: '70px',
                                            }}
                                            disabled={record.isCompleted}
                                        />
                                    </Tooltip>
                                </Popconfirm>
                            )}
                            <Tooltip title={t('update')} placement="top">
                                <Button
                                    size='small'
                                    icon={<EditOutlined />}
                                    style={{
                                        display: userInfo.role === UserRole.Personel ? 'none' : 'inline-block',
                                        width: '60px',
                                        borderRadius: '70px'
                                    }}
                                    onClick={() => {
                                        window.location.replace(`/admin/update-fault/${record.maintenanceId}`);
                                    }}
                                    disabled={record.isCompleted}
                                />
                            </Tooltip>
                        </Space>
                    </div>
                );
            },
        },
    ];

    return (
        <>
            <Toast ref={toast} />
            <Row gutter={16} style={{ marginTop: '20px' }}>
                <Col xs={24} sm={8} md={6} lg={4} xl={4} style={{ paddingLeft: '8px' }}>
                    <Button
                        type="primary"
                        shape="round"
                        style={{
                            height: 64,
                            width: 'auto',
                            backgroundColor: 'transparent',
                            color: '#1890ff',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginLeft: '5px',
                            padding: 0,
                            border: 'none',
                            display: 'flex',
                            transition: 'all 0.3s ease',
                            cursor: 'pointer',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.2)';
                            e.currentTarget.style.color = '#40a9ff';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.boxShadow = 'none';
                            e.currentTarget.style.color = '#1890ff';
                        }}
                        size="middle"
                        icon={<ExclamationCircleOutlined style={{ fontSize: 24 }} />}
                        onClick={() => window.location.replace('/admin/add-fault')}
                    >
                        <span style={{ fontSize: '12px', marginTop: '8px', textAlign: 'center' }}>
                            {t('create_fault')}
                        </span>
                    </Button>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} xl={24} style={{ marginTop: '10px', paddingLeft: '8px' }}>
                    <MUIDatagrid
                        ref={dataGridRef}
                        data={careData.data}
                        total={careData.count}
                        columns={columns}
                        onSelectionChange={handleRowSelection}
                        enableSelection={false}
                        showStatusIcons={true}
                        filterMode='server'
                        onChange={FaultFilter}
                    />
                </Col>

                <Modal
                    title={<span style={{ fontWeight: 'bold' }}>{t('completedStatus')}</span>}
                    visible={isModalVisible}
                    onOk={handleOk}
                    onCancel={() => {
                        setCompletionDescription('');
                        handleCancel();
                    }}
                >
                    <p>{t('isCompletedModalMessage')}</p>
                    <Input
                        placeholder={t('enter_completion_description')}
                        value={completionDescription}
                        onChange={(e) => setCompletionDescription(e.target.value)}
                        style={{ marginTop: '16px', borderRadius: '5px' }}
                    />
                </Modal>
            </Row>
        </>
    );
};


export default FaultManagement;
